/**
 * Banner Helper to load banners (BannerDto) for display in the viewer or in the future in other views/components
 */

import {ClientManager} from "@/singletons/ClientManager";
import type {BannerDto} from "@dex/squeeze-client-ts";

/**
 * Loads banner messages
 * The backend returns translated text (DE/EN) based on the request language.
 *
 * @param documentClassId Optional document class when urls need this parameters
 * @param batchClassId Optional batch class when urls need this parameters
 * @returns The banners (BannerDto)
 */
export const loadBannerMessages = async (documentClassId?: number, batchClassId?: number): Promise<BannerDto[]> => {
	try {
		return await ClientManager.getInstance().squeeze.dexp.getDexpBanner(documentClassId, batchClassId);
	} catch (error) {
		return [];
	}
};
